(ns ycweb.components.datatables.select
  (:require
   [rum.core :as rum]))

(defn multi-select [table-atom idx-key]
  (let [set-rows (or (:select @table-atom) #{})]
    (cond
      (contains? (set set-rows) idx-key)
      (swap! table-atom assoc :select (disj set-rows idx-key))

      :else
      (swap! table-atom assoc :select (conj set-rows idx-key)))))

(defn single-select [table-atom idx-key]
  (let [set-rows (or (:select @table-atom) #{})]
    (cond
      (contains? (set set-rows) idx-key)
      (swap! table-atom dissoc :select)
      ;;if using the selector column on DataTables...
      ;;(rum/cursor-in raw-data-atom [idx-key :selected?])
      ;;these need to be set to false as well
      ;;Quick fix is to enable a radio button....

      :else
      (swap! table-atom assoc :select #{idx-key}))))

(defn select [table-atom idx-key]
  (let [{:keys [select?]} @(rum/cursor table-atom :config)]
    (cond
      (or
        (and (boolean? select?) select?)
        (= (:style select?) :single))
      (single-select table-atom idx-key)

      (or
        (= (:style select?) :os)
        (= (:style select?) :multi))
      (multi-select table-atom idx-key))))